import React from 'react';

export const LoginPageLogo = (
  props: React.SVGProps<SVGSVGElement>,
): JSX.Element => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <svg
      width="100%"
      height="21px"
      viewBox="0 0 1754 269"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M537.554 225.312C466.972 225.312 429.965 209.919 428.74 163.501H462.805C462.805 190.678 484.862 201.261 537.554 201.261C583.383 201.261 602.5 193.805 602.5 173.362C602.5 153.159 588.285 150.273 535.838 146.906L526.035 146.184C457.904 142.096 433.886 128.627 433.886 93.9938C433.886 60.082 467.462 45.6514 528.486 45.6514C594.657 45.6514 627.988 64.8922 628.968 104.576H595.147C595.147 77.8796 570.885 69.7023 525.79 69.7023C483.637 69.7023 467.707 76.4366 467.707 93.9938C467.707 113.956 482.412 118.285 530.447 121.652L540.74 122.374C602.254 126.703 636.32 131.513 636.32 172.4C636.32 212.805 599.068 225.312 537.554 225.312Z"
        fill="white"
      />
      <path
        d="M667.92 220.502V49.9806H838.984V74.753H700.76V123.576H834.082V146.665H700.76V195.489H838.984V220.502H667.92Z"
        fill="white"
      />
      <path
        d="M864.24 220.502L960.556 49.9806H1002.22L1098.04 220.502H1063L1041.68 181.539H920.853L899.532 220.502H864.24ZM934.087 157.488H1028.44L981.387 71.1454L934.087 157.488Z"
        fill="white"
      />
      <path
        d="M1122.48 220.502V49.9806H1253.11C1294.53 49.9806 1309.97 68.0188 1309.97 92.5507C1309.97 111.31 1299.18 125.26 1280.56 131.994C1302.37 137.045 1320.01 149.07 1320.01 174.083C1320.01 202.223 1301.63 220.502 1264.14 220.502H1122.48ZM1155.32 196.451H1253.84C1274.18 196.451 1285.95 188.754 1285.95 170.476C1285.95 150.754 1270.26 144.982 1253.84 144.982H1155.32V196.451ZM1155.32 124.298H1244.04C1261.69 124.298 1277.37 118.285 1277.37 98.8039C1277.37 81.4873 1265.61 74.0315 1244.04 74.0315H1155.32V124.298Z"
        fill="white"
      />
      <path
        d="M1348.41 220.502V49.9806H1519.48V74.753H1381.25V123.576H1514.57V146.665H1381.25V195.489H1519.48V220.502H1348.41Z"
        fill="white"
      />
      <path
        d="M1553.28 220.502V49.9806H1686.36C1732.43 49.9806 1754 67.0567 1754 99.0445C1754 121.652 1741.5 137.045 1717.73 143.058C1738.81 143.779 1752.77 155.564 1752.77 175.767V220.502H1720.18V180.337C1720.18 164.944 1712.34 158.45 1696.65 158.45H1586.12V220.502H1553.28ZM1586.12 131.994H1679.5C1705.96 131.994 1720.18 124.057 1720.18 103.374C1720.18 82.9303 1705.96 76.1961 1679.5 76.1961H1586.12V131.994Z"
        fill="white"
      />
      <path d="M0.499695 0H274.653V44.8333H0.499695V0Z" fill="#FFE552" />
      <path
        d="M0.499695 89.6666H137.576V134.5H46.1919C20.9568 134.5 0.499695 114.427 0.499695 89.6666Z"
        fill="#FFE552"
      />
      <path
        d="M137.576 134.5H228.961C254.196 134.5 274.653 154.572 274.653 179.333H137.576V134.5Z"
        fill="#FFE552"
      />
      <path
        d="M0.499695 224.166H274.653V269H0.499695V224.166Z"
        fill="#FFE552"
      />
    </svg>
  </div>
);

LoginPageLogo.displayName = 'LoginPageLogo';

export default LoginPageLogo;
